<template>
  <sl-page>
    <div class='page-filter'>
      <Row :gutter="12">
        <Col span="6" :lg="6" :md="12" :sm="12" :xs="24" class="margin-bottom">
        <Cascader :data="areaData" v-model="params.districtCodes" placeholder="请选择省市区" change-on-select></Cascader>
        </Col>
        <Col span="6" :lg="6" :md="12" :sm="12" :xs="24" class="margin-bottom">
        <Input v-model="params.companyName" placeholder="请输入企业名称" clearable></Input>
        </Col>
        <Col span="6" :lg="6" :md="12" :sm="12" :xs="24" class="margin-bottom">
        <Input v-model="params.brandName" placeholder="请输入企业品牌" clearable></Input>
        </Col>
        <Col span="6" :lg="6" :md="12" :sm="12" :xs="24" class="page-action">
        <div style="width: 100%;">
          <Button type="primary" icon="ios-search" @click="queryInit()">搜索</Button>
          <Button @click="reset()">清空</Button>
          <exportBtn style="float: right;" v-if="$auth.access('std.progress.export')" ref="exportBtn" requestKey="standardProgressReportExport" @click.native="handleExport()"></exportBtn>
        </div>
        </Col>
      </Row>
    </div>
    <div>
      <chart ref="chart"></chart>
    </div>
    <div class="pg-bd">
      <sl-table ref="table" :loading="loading" :page="page" :columns="columns" :data="data" @on-selection-change="handleSelect" @on-update="handleChange"></sl-table>
    </div>
  </sl-page>
</template>
<script>
import { areaData } from '@/util/area.js'

import dics from './dics'
import { mapState } from 'vuex'
import chart from './chart'
import item from './item'
import exportBtn from '../exportBtn'
export default {
  components: { chart, item, exportBtn },
  data() {
    return {
      ...dics,
      areaData: areaData,
      columns: [{
          type: 'index',
          width: 65,
          title: '序号',
          align: 'center'
        },
        {
          title: '企业信息',
          minWidth: 300,
          render: (h, params) => {
            let row = params.row
            let H = h(item, {
              props: { row: row },
            })
            return H
          }
        },
        {
          title: '快递员数',
          key: 'courierNum',
          minWidth: 100,
        },
        {
          title: '上岗证',
          minWidth: 260,
          render: (h, params) => {
            let row = params.row
            let H = h('div', {
              props: { row: row },
              style: { display: 'flex' },
            }, [h('span', { style: { flex: 1 }, }, `待申请:${row.notApplyNum}`),
              h('span', { style: { flex: 1 }, }, `待考试:${row.dksNum}`),
              h('span', { style: { flex: 1 }, }, `已发放:${row.jzyffNum}`)
            ])
            return H
          }
        },
        {
          title: '全部车辆',
          key: 'carTotalNum',
          minWidth: 100,
        },
        {
          title: '上报车辆',
          key: 'reportCarNum',
          minWidth: 100,
        },
        {
          title: '上报通过',
          key: 'checkPassCarNum',
          minWidth: 100,
        },
        {
          title: '信息待修改',
          key: 'waitUpdateCarNum',
          minWidth: 100,
        },
        {
          title: '车辆不达标',
          key: 'standardizationFailNum',
          minWidth: 100,
        },
        {
          title: '已取消',
          key: 'cancelCarNum',
          minWidth: 100,
        },
        {
          title: '安装申请',
          key: 'installationApplyNum',
          minWidth: 100,
        },
        {
          title: '控件',
          minWidth: 250,
          render: (h, params) => {
            let row = params.row
            let H = h('div', {
              props: { row: row },
              style: { display: 'flex' },
            }, [h('span', { style: { flex: 1 }, }, `待审核:${row.controlReview}`),
              h('span', { style: { flex: 1 }, }, `已完成:${row.controlFinish}`),
              h('span', { style: { flex: 1 }, }, `已确定:${row.controlConfig}`)
            ])
            return H
          }
        },
        {
          title: '车牌申请',
          key: 'licensePlateApplicationNum',
          minWidth: 100,
        },
        {
          title: '标准化已完成',
          key: 'standardizationCompleted',
          minWidth: 110,
        },
        {
          title: '完成率',
          minWidth: 100,
          render: (h, params) => {
            let row = params.row
            let completionRate = row.completionRate
            let p = 0
            if (completionRate) {
              p = completionRate * 100
            } else {
              p = 0
            }

            let txt = p + '%'

            return h('div', txt)
          }
        },
      ],
      data: [],
      params: {
        brandName: null,
        companyName: null,
        districtCodes: [],
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      selection: [],
      dateArr: null,
    }
  },
  computed: {
    removeDisable() {
      return this.selection.length == 0
    },
  },
  created() {
    this.def = JSON.parse(JSON.stringify(this.params))
    this.queryInit()
  },

  methods: {
    queryInit() {
      this.page = {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
      this.list()
      this.queryChart()
    },
    getSearch() {
      // 搜索值过滤
      let search = this.$utils.filterSearch(this.params)
      // 省市区
      if (search.districtCodes && search.districtCodes.length > 0) {
        let i = search.districtCodes.length - 1
        search.districtCode = search.districtCodes[i]
        delete search.districtCodes
      }
      return search
    },

    list() {
      // 搜索值过滤
      let search = this.getSearch()

      let params = { search: search, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      this.data = []
      this.$request.standardProgressReportPage(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = resp.data.list || []
          this.page.total = resp.data.total || 0
        }
      })
    },


    create() {

    },

    reset() {
      this.dateArr = null
      this.$utils.fill(this.params, this.def)
      this.list()
      this.queryChart()
    },

    handleUpdate() {
      this.modalVisible = false
      this.list()
    },

    handleChange(pageNum, pageSize) {
      if (this.page.pageNum != pageNum || this.page.pageSize != pageSize) {
        this.page.pageNum = pageNum
        this.page.pageSize = pageSize
        this.list()
      }
    },

    handleSelect(selection) {
      this.selection = selection.map(i => i.id)
    },

    onUpdatelist() {
      this.list()
    },
    queryChart() {
      // 搜索值过滤
      let search = this.getSearch()
      let data = search
      this.$request.standardProgressReportChart(data).then(resp => {
        let obj = resp.data || {}
        let complate = obj.complate || 0
        let unComplate = obj.unComplate || 0
        let fail = obj.fail || 0
        let total = obj.total || 0

        let arr = [{ value: fail, name: '不达标' }, { value: complate, name: '标准化完成' }, { value: unComplate, name: '标准化未完成' }]
        this.$refs.chart.setData(arr, total)
      })
    },
    handleExport() {
      let search = this.getSearch()
      this.$refs.exportBtn.handleExport(search)
    },
  }
}
</script>